import React, { type PropsWithChildren } from "react";

import { ApolloError } from "@apollo/client";
import { usePrefs } from "@utils/client-side-preferences";

import DevelopmentAnalyticsDataErrorScreen from "./error-pages/development-analytics-data-error-screen";

export class DevelopmentAnalyticsDataErrorBoundaryComponent extends React.Component<
  PropsWithChildren<{ useDevelopmentAnalyticsData: boolean }>
> {
  state = { hasError: false };

  static getDerivedStateFromError(error: any) {
    if (error instanceof ApolloError && error.message.includes("Not found")) {
      return { hasError: true };
    } else {
      throw error;
    }
  }

  render() {
    if (this.state.hasError && this.props.useDevelopmentAnalyticsData) {
      return <DevelopmentAnalyticsDataErrorScreen />;
    }

    return this.props.children;
  }
}

export function DevelopmentAnalyticsDataErrorBoundary({
  children,
}: PropsWithChildren<unknown>) {
  const { useDevelopmentAnalyticsData } = usePrefs();
  return (
    <DevelopmentAnalyticsDataErrorBoundaryComponent
      useDevelopmentAnalyticsData={useDevelopmentAnalyticsData}
    >
      {children}
    </DevelopmentAnalyticsDataErrorBoundaryComponent>
  );
}
